export const en_US = 'en';
export const fa_IR = 'fa';

export const localeOptions = [
  {id: en_US, name: 'English', direction: 'ltr'},
  {id: fa_IR, name: 'فارسی', direction: 'rtl'},
];

export default fa_IR;
